import { Column } from '..';
import './Convertion.scss';

export const Convertion = ({
  children,
  color,
  topTitle,
  title,
  description,
  ...otherProps
}) => {
  return (
    <Column customClass="convertion" {...otherProps}>
      <div className="right">
        <h4 className="top-title" style={{ color: color }}>
          {topTitle}
        </h4>
        <h2 className="title">{title}</h2>
        <h3 className="description">{description}</h3>
      </div>
      <div className="left">{children}</div>
    </Column>
  );
};
